var map = {
	"./Covid/inspiration.png": "32b5",
	"./Financely/inspiration.png": "5e5e",
	"./Hotpot/inspiration.png": "ca40",
	"./Linkedin/inspiration.png": "f2f7",
	"./QRPay/inspiration.png": "c094",
	"./Rabbit/inspiration.png": "fd28",
	"./Vibeify/inspiration.png": "9b47",
	"./Watchlist/inspiration.png": "98ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3be9";